import styledComp from 'styled-components';
import styled from '@mui/styles/styled';

import { Styling } from '../../../../../constants';

export const SelectedAssetsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  padding-top: ${Styling.DEFAULT_SPACING}px;
  padding-bottom: ${Styling.DEFAULT_SPACING}px;
  width: fill-available;
`;

export const SelectedAssetsItemList = styledComp.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  max-height: 188px;
  overflow-y: auto;
  padding: 10px 0;
  background-color: #f7f7f7;
`;

export const SelectedAssetsInfoText = styledComp.span`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: ${Styling.DEFAULT_SPACING}px;
`;

export const SelectedAssetText = styledComp.span`
  display: flex;
  flex-grow: 1;
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
  &.unPublishable {
    text-decoration: line-through;
  }
`;

export const SelectedAssetItem = styledComp.div`
  display: flex;
  align-items: center;
  .MuiInputBase-root {
    width: 200px;
    height: 40px;
    overflow: hidden;
  }
`;
